import { Injectable } from '@angular/core';

@Injectable()
export class GlobalHelpers {
  nullOrEmpty(checkObj: any) {
    if (checkObj) {
      return false;
    }
    return true;
  }
}
